export default __webpack_public_path__ + "static/media/rax.f06e79c8.svg";